import {computed, defineComponent, type PropType, ref, watch} from 'vue';
import {AthumiService, type InvoiceSettings, type OperationsActorServiceInfo} from "@/api/enterprise-gateway-api.proxy.ts";
import {Button} from 'primevue';

export default defineComponent({
    name: 'AegActorInfo',
    components: { Button },
    props: {
        actorServiceInfo: {
            type: Object as PropType<OperationsActorServiceInfo | undefined>,
            required: false,
            default: undefined
        },
        invoiceSettings: {
            type: Array as PropType<InvoiceSettings[] | undefined>,
            required: false,
            default: undefined
        },
        isCitizen: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: {
        'invoice-settings-saved': (updatedSettings: InvoiceSettings) => true,
    },
    setup: function (props, { emit }) {
        const actorInfo = ref<OperationsActorServiceInfo | undefined>();
        const emails = ref<string>('');
        const editActorModalVisible = ref<boolean>(false);
        const editSettingsModalVisible = ref<boolean>(false);

        const isKlip = computed<boolean>(() => {
            return actorInfo.value?.service === AthumiService.Klip;
        });

        const formatAmount = (amount: number | undefined): string => {
            if (amount === undefined || amount === null) return '0,00';
            return amount.toFixed(2).replace('.', ',');
        };

        const editActorEmails = () => {
            editActorModalVisible.value = true;
        };

        const editSettings = (settings: InvoiceSettings) => {
            // const settingsModalId = getModalId(settings.invoiceSettingsId!);
            // const modalEventsUtil = useModalEventsUtil(settingsModalId);
            // modalEventsUtil.triggerModalToggle();
            editSettingsModalVisible.value = true;
        };

        const handleInvoiceSettingsSaved = (updatedSettings: InvoiceSettings) => {
            emit('invoice-settings-saved', updatedSettings);
        };

        const updateActorEmails = (actorEmails: {emails: string[]}) => {
            emails.value = actorEmails.emails.join(', ') || '';
        };

        const actorChanged = async (newActorServiceInfo: OperationsActorServiceInfo | undefined) => {
            actorInfo.value = newActorServiceInfo;
            emails.value = newActorServiceInfo?.emails?.join(', ') || '';
        };

        watch(() => props.actorServiceInfo, actorChanged, {immediate: true, deep: true});

        return {
            actorInfo,
            editActorModalVisible,
            editSettingsModalVisible,
            isKlip,
            isCitizen: props.isCitizen,
            invoiceSettings: props.invoiceSettings,
            emails,
            formatAmount,
            editActorEmails,
            editSettings,
            handleInvoiceSettingsSaved,
            updateActorEmails
        }
    }
});
